import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
import { actionExamples } from '../../data/home';
import { demoUrlFor } from '../../data/demoCenter';
import { easeOutStrong, fadeUp } from '../../utils/motion';

/** "From knowledge to action": three concrete, demo-backed examples. */
export function HomeActionExamples() {
  return <section aria-labelledby="action-title" className="bg-navy text-white py-20 lg:py-28" data-id="element-1112" data-mp="1ay6grayg7ko1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1113" data-mp="1otidtp02tn84">
        <motion.h2 {...fadeUp} id="action-title" className="font-heading font-bold text-4xl lg:text-5xl tracking-tight max-w-2xl mb-16" data-id="element-1114" data-mp="1kt87uccaawt9">
          From knowledge to action
        </motion.h2>

        <ol className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-10" data-id="element-1115" data-mp="1toee1cfgvgwb">
          {actionExamples.map((example, index) => <motion.li key={example.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.3,
          delay: index * 0.06,
          ease: easeOutStrong
        }} className="flex flex-col border-t border-white/25 pt-8" data-id="element-1116" data-mp="23kr8iciu5ys4" data-mpi={index}>
              <p className="text-sm font-medium text-teal" data-id="element-1117" data-mp="3vod1j3wj6e8c">{example.who}</p>
              <h3 className="mt-2 font-heading font-bold text-2xl leading-snug" data-id="element-1118" data-mp="4h0n2wn18ew4">{example.title}</h3>
              <p className="mt-3 mb-6 text-white/75 text-lg leading-relaxed" data-id="element-1119" data-mp="9ek1bwjqcro2">{example.body}</p>
              <a href={demoUrlFor(example.domain)} target="_blank" rel="noopener noreferrer" className="mt-auto inline-flex items-center gap-1.5 text-sm font-semibold text-white hover:text-teal transition-colors duration-150 whitespace-nowrap" data-id="element-1120" data-mp="ec2c7shb5gyp">
                Try it in the demo
                <ArrowUpRight size={14} aria-hidden="true" data-id="element-1121" data-mp="x3lefx3icqzo" />
                <span className="sr-only" data-id="element-1122" data-mp="x21tht6wprrk">(opens in a new tab)</span>
              </a>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}